<template>
  <div class="client-signature">
    <div class="signature-title">乙方代表签名</div>
    <div :class="` ${isStartGenerate ? '' : 'border-1px'}`">
      <div
        class="esign-box"
        v-if="!signatureImg"
        :style="`pointer-events: ${sginData ? 'none' : 'auto'};`"
      >
        <vue-esign :key="width" ref="esign" :width="width" :height="height" />
      </div>
      <div v-else class="esign-box">
        <img
          :src="signatureImg"
          :width="width"
          :height="height"
          alt=""
          crossorigin="Anonymous"
        />
      </div>
      <div v-if="!isStartGenerate" class="signature-tip border-1px-top">
        <div class="tip-text">签署签名后请点击[确认签名]，系统将自动生图片</div>
        <div class="tip-btn">
          <div v-if="!sginData" class="btn" @click="handleGenerate">
            确认签名
          </div>
          <div v-else class="btn" style="color: #999">已生成签名</div>
          <div class="btn" @click="handleReset">重置签名</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueEsign from "vue-esign";
import { Message } from "element-ui";
import { Toast } from "vant";
import { getTerminalInfo } from "@/utils/platformInfo";
export default {
  name: "ContractSignature",

  components: {
    vueEsign,
  },
  props: {
    isStartGenerate: {
      type: Boolean,
      default: false,
    },
    signatureImg: {
      type: String,
      default: "",
    },
    status: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      width: 0,
      height: 180,
      showSignatureImg: true,
      sginData: "",
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.width = document.querySelector(".client-signature").clientWidth;
    });
  },
  methods: {
    handleGenerate() {
      if (this.status === 1 || this.status === 2) {
        return;
      }
      this.$refs.esign
        .generate()
        .then((res) => {
          this.sginData = res;
          this.$emit("getSignature", res);
        })
        .catch((err) => {
          this.toast("签名为空", "warning");
          console.log(err); // 画布没有签字时会执行这里 'Not Signned'
        });
    },
    getSubmitData() {
      console.log(this.sginData, "this.sginData");
      if (!this.sginData) {
        this.toast("请确认签名", "warning");
        return false
      }
      return {
        partyBSignature: this.sginData,
      };
    },
    handleReset() {
      this.sginData = false;
      this.$refs.esign.reset();
    },
    toast(msg, type) {
      const isMobile = getTerminalInfo() === "mobile";
      if (isMobile) {
        Toast({
          message: msg,
          position: "bottom",
        });
      } else {
        Message[type](msg);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.pc {
  .border-1px {
    padding-left: 1px;
    border: 1px solid #ccc;
  }

  .border-1px-top {
    border-top: 1px solid #ccc;
  }
}

.signature-title {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
  padding-top: 10px;
}

.signature-tip {
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: space-between;

  .tip-text {
    font-size: 12px;
    color: #999;
  }

  .tip-btn {
    display: flex;
    align-items: center;

    .btn {
      color: #000;
      background: #f1f1f1;
      padding: 10px 20px;
      font-size: 12px;
      cursor: pointer;

      &:first-child {
        margin-right: 10px;
      }
    }
  }
}

.esign-box {
  overflow: hidden;

  img {
    display: block;
    margin-top: 10px;
    overflow: hidden;
    object-fit: contain;
  }
}

.mobile .signature-tip {
  display: block;

  .tip-btn {
    margin-top: 10px;

    .btn {
      width: 50%;
      text-align: center;
    }
  }
}
</style>
